import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from './store'
// import './assets/iconfont/iconfont.css';
// import './assets/iconfont/iconfont.js';
import request from './utils/request';
import * as filters from './filters';
import VConsole from 'vconsole'

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});
// const vconsole = new VConsole()
Vue.config.productionTip = false;
Vue.prototype.$http = request;
Vue.prototype.$isWeChat = /MicroMessenger/.test(window.navigator.userAgent);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
